import React, {forwardRef} from "react";

export interface CustomToggleProps {
    children: React.ReactNode;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const CustomToggle = forwardRef<HTMLButtonElement, CustomToggleProps>((props, ref) => {
    const { children, onClick } = props;
    return (
        <button
            ref={ref}
            type="button"
            className="btn dashboardBtn"
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </button>
    );
});
